import { combineReducers } from 'redux'
import windowWidth from './window-width'
import shouldShowMobileCategory from './should-show-mobile-category'
import shouldScroll from './should-scroll'

export default combineReducers({
  windowWidth: windowWidth,
  shouldShowMobileCategory: shouldShowMobileCategory,
  shouldScroll: shouldScroll,
})
